import { createFileRoute } from '@tanstack/react-router';

import { ShortcutsPage } from '@/pages/help/shortcuts-page';

export const Route = createFileRoute('/shortcuts')({
  component: ShortcutsPage,
});
